import React, { useEffect, useState } from 'react'
import { ClientsDashbaordTicketView } from '../../views'
import { ClientsService, LocalStorageService } from '../../../services';
import { useParams, useHistory } from 'react-router-dom';

const url = process.env.REACT_APP_ETICKET_API;
const localStorageService = new LocalStorageService();
let token = localStorageService.getLocalStorageItem("token")
if (token) token = token.idToken
const clientsService = new ClientsService(url)

function ClientsDashboardTicketAction() {
    const { ticketId } = useParams()
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const toggleError = (message) => setErrorMessage(message)

    const onLoad = async () => {
        try {
            setIsLoading(true)
            toggleError(null)
            const data = await clientsService.getTicketDetails(token, ticketId)
            setData(data)
            console.log(data)
            setIsLoading(false)
        } catch (err) {
            toggleError(err.message)
        }
    }

    const handleBack = () => {
        history.goBack()
    }

    useEffect(() => {
        onLoad()
    }, [])

    return (
        <ClientsDashbaordTicketView
            isLoading={isLoading}
            errorMessage={errorMessage}
            data={data}
            handleBack={handleBack}
        />
    )
}

export default ClientsDashboardTicketAction